import { SessionDocumentInfo } from '@arc/unified-payments-frontend/shared-payment';
import { createSelector } from '@ngrx/store';
import { selectPaymentPreviewPayables } from '../btpay';
import { selectSelectedDocuments } from '../session-store';

export const selectPaymentPreviewDocuments = createSelector(
  selectPaymentPreviewPayables,
  selectSelectedDocuments,
  (payables, documents) => {
    if (payables == null) {
      return null;
    }

    const docs: SessionDocumentInfo[] = [];
    documents.forEach((document) => {
      const payable = payables.find((p) => p.burn === document.urn);
      let surchargeAmount = 0;
      if (payable) {
        surchargeAmount = payable.surcharge;
      }

      docs.push({
        ...document,
        surchargeAmount,
      });
    });

    return docs;
  },
);
